import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import FixedTooltipPortal from 'dpl/common/tooltip/components/FixedTooltipPortal';
import useSearchResultsContext from 'dpl/puppy_search_results/hooks/useSearchResultsContext';
import Icon from 'dpl/common/components/Icon';

import FilterButtonActions from './FilterButtonActions';

const CLOSE_ICON_SIZE = '32px';

export default function ExposedFilterBottomModal({
  isFilterMenuOpen,
  setIsFilterMenuOpen,
  resultsType,
  totalItemCount,
  title,
  children,
  actionsClassName
}) {
  const { sendBreedSearchedAnalytics } = useSearchResultsContext();

  function handleCloseClick() {
    setIsFilterMenuOpen(false);
    sendBreedSearchedAnalytics();
  }

  return (
    <FixedTooltipPortal
      isVisible={isFilterMenuOpen}
      onCloseClick={handleCloseClick}
      className="relative ph5 pt5"
      wrapperClassName={classnames('flex flex-column justify-end', {
        'top-1': isFilterMenuOpen
      })}
      style={{ paddingBottom: 0, maxHeight: '100%' }}
      shouldHideCloseButton
    >
      <p
        className="font-24 font-serif fw-medium mb8 dib"
        style={{ maxWidth: `calc(100% - (${CLOSE_ICON_SIZE} + 16px))` }}
      >
        {title}
      </p>
      <button
        type="button"
        onClick={handleCloseClick}
        className="sticky top-0 right-0 fr secondary z-999"
        data-test-id="close-button"
      >
        <Icon
          name="close"
          className="ph2 pv2 ba b--light-gray br-100 bg-white"
          height={CLOSE_ICON_SIZE}
          width={CLOSE_ICON_SIZE}
        />
      </button>
      <div className="pb8">{children}</div>
      <FilterButtonActions
        className={classnames(
          'sticky bottom-0 bg-white nh5 pb5 ph5',
          actionsClassName
        )}
        setIsMenuOpen={() => setIsFilterMenuOpen(false)}
        totalItemCount={totalItemCount}
        resultsType={resultsType}
      />
    </FixedTooltipPortal>
  );
}

ExposedFilterBottomModal.propTypes = {
  isFilterMenuOpen: PropTypes.bool.isRequired,
  setIsFilterMenuOpen: PropTypes.func.isRequired,
  resultsType: PropTypes.string.isRequired,
  totalItemCount: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  actionsClassName: PropTypes.string
};

ExposedFilterBottomModal.defaultProps = {
  actionsClassName: ''
};
